import { IEltBusinessPerformanceData } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltBusinessPerformanceData'
import { IEltCompanyPerformanceItem } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltCompanyPerfomance'
import { IEltCustomerRevenue } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltCustomerRevenue'
import { IEltDocCompany } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltDocCompany'
import { IEltTopIssue } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltTopIssue'
import { IEltTopOpportunity } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltTopOpportunity'
import { IHpSob } from 'legacy/lut/classes/models/partner360/ELT/financialData/hpSob/IHpSob'
import { IKpi } from 'legacy/lut/classes/models/partner360/ELT/financialData/kpi/IKpi'
import {
  ICompetitorsSnapshot,
  TCompetitorsSnapshotKeys,
  TRevenueSnapshotKeys,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { Nullable } from 'clickNgo/models/utils'

import { IPLCParams } from './IPLCParams'

export enum ELT_FORM_SECTION {
  MAIN_INFO = 'MeetingMainInfo',
  HP_ATTENDEES = 'HpAttendees',
  ACCOUNT_ATTENDEES = 'AccountAttendees',
  MEETING_AGENDA = 'MeetingAgenda',

  MEETING_PURPOSE = 'MeetingPurpose',
  LONG_TERM_PRIORITIES = 'LongTermPriorities',
  SHORT_TERM_PRIORITIES = 'ShortTermPriorities',
  SUPPORTING_PRIORITIES = 'SupportingPriorities',
  MEETING_SUMMARY = 'MeetingSummary',
  COMPANY_AT_GLANCE = 'CompanyAtGlance',
  COMPANY_AT_GLANCE_INPUTS = 'CompanyAtGlanceInputs',
  NEED_SUPPORT = 'NeedSupport',
  SUPPORT_TOPICS = 'SupportTopics',
  REVENUE = 'Revenue',
  COMPETITORS = 'CompetitiveLandscape',
  FINANCIAL_PERFORMANCE = 'FinancialPerformance',
  GOOD_NEWS_DESC = 'GoodNewsDesc',
  ISSUES = 'Issues',
  KEY_OPPORTUNITIES = 'KeyOpportunities',
  HIDDEN_SECTIONS = 'HiddenSections',
  BALANCE_OF_TRADE = 'BalanceOfTrade',
  BALANCE_OF_TRADE_SUMMARY = 'BalanceOfTradeSummary',
  SOLD_PRODUCT_DATA = 'SoldProductData',
  SOLD_PRINT_PRODUCTS = 'SoldPrintProducts',
  SOLD_PS_PRODUCTS = 'SoldPSProducts',
  SOLD_SERVICES_PRODUCTS = 'SoldServicesProducts',
  HP_SOB = 'HPSob',
  LAST_MEETING = 'LastMeetingData',

  //common
  LAST_ENGAGEMENT = 'LastEngagement',

  //doc
  MEETING_OBJECTIVES = 'MeetingObjectives',
  HP_EXECUTIVE_KEY_POINTS = 'HpExecutiveKeyPoints',
  ADDITIONAL_NOTES = 'AdditionalNotes',
  TOP_ISSUES = 'TopIssues',
  COMPANY_INFO = 'Company',
  TOP_OPPORTUNITIES = 'TopOpportunities',
  CUSTOMER_REVENUE = 'CustomerRevenue',
  COMPANY_PERFORMANCE = 'CompanyPerformance',
  BUSINESS_PERF_DATA = 'BusinessPerformanceData',
}

export type TComplexSectionData =
  | IAttendee[]
  | IMeeetingAgenda[]
  | ISupportTopic[]
  | IRevenue[]
  | ICompetitor[]
  | IIssue[]
  | IOpportunity[]
  | IEltTopOpportunity[]
  | IBalanceOfTrade[]
  | IHpSob[]
  | string[]
  | IELTLastMeetingData[]
  | ISoldProductData
  | ICategorySoldProducts[]
  | IEltTopIssue[]
  | IEltDocCompany
  | IEltCustomerRevenue[]
  | IEltCompanyPerformanceItem[]
  | IEltBusinessPerformanceData[]

export interface IMeetingMainInfo {
  CompanyAdminEmail: string
  CompanyAdminName: string
  CompanyAdminWorkPhonePrefix: string
  CompanyAdminWorkPhone: string
  CompanyContactEmail: string
  CompanyContactName: string
  CompanyContactWorkPhonePrefix: string
  CompanyContactWorkPhone: string
  HPContactEmail: string
  HPContactName: string
  HPContactPhoneCode: string
  HPContactPhone: string
  HpExecutiveSponsor: string
  HpExecutiveSponsorIsApplicable: string
  MeetingDateTime: string
  MeetingLocation: string
  AccountSegment: string
}

export interface IAttendee {
  Email: string
  Title: string
  Name: string
}

export interface ISchedule {
  Start: string | null
  End: string | null
}
export interface IMeeetingAgenda {
  Topic: string
  Time: number
  Schedule: ISchedule
  Presenter: string
}

export interface ISupportTopic {
  TopicArea: string
  TalkingPoints: string
}

export interface IMeetingSummary {
  Bio: string
}

export interface ICompanyAtGlance {
  Info: string
}

export interface IRevenue {
  Key: TRevenueSnapshotKeys
  Name: string

  YoY: number | null
  YoYNet: number | null
  YoYTNet: number | null
  YoYUTNet: number | null

  CurrentYearRevenue: number
  CurrentYearRevenueNet: number
  CurrentYearRevenueTNet: number
  CurrentYearRevenueUTNet: number

  PreviousYearRevenue: number
  PreviousYearRevenueNet: number
  PreviousYearRevenueTNet: number
  PreviousYearRevenueUTNet: number

  CurrentYearQuarter1: number
  CurrentYearQuarter1Net: number
  CurrentYearQuarter1TNet: number
  CurrentYearQuarter1UTNet: number

  CurrentYearQuarter2: number
  CurrentYearQuarter2Net: number
  CurrentYearQuarter2TNet: number
  CurrentYearQuarter2UTNet: number

  CurrentYearQuarter3: number
  CurrentYearQuarter3Net: number
  CurrentYearQuarter3TNet: number
  CurrentYearQuarter3UTNet: number

  CurrentYearQuarter4: number
  CurrentYearQuarter4Net: number
  CurrentYearQuarter4TNet: number
  CurrentYearQuarter4UTNet: number

  PrevYearQuarter1: number
  PrevYearQuarter1Net: number
  PrevYearQuarter1TNet: number
  PrevYearQuarter1UTNet: number

  PrevYearQuarter2: number
  PrevYearQuarter2Net: number
  PrevYearQuarter2TNet: number
  PrevYearQuarter2UTNet: number

  PrevYearQuarter3: number
  PrevYearQuarter3Net: number
  PrevYearQuarter3TNet: number
  PrevYearQuarter3UTNet: number

  PrevYearQuarter4: number
  PrevYearQuarter4Net: number
  PrevYearQuarter4TNet: number
  PrevYearQuarter4UTNet: number

  TwoYearsAgo: number
  TwoYearsAgoNet: number
  TwoYearsAgoTNet: number
  TwoYearsAgoUTNet: number

  ThreeYearsAgo: number
  ThreeYearsAgoNet: number
  ThreeYearsAgoTNet: number
  ThreeYearsAgoUTNet: number
}

export interface IBalanceOfTrade {
  Key: 'BalanceOfTrade' | 'HPSpend' | 'TotalRevenue'
  Name: string

  PrevYearTotal: number
  PrevYearTotalNet: number
  PrevYearTotalTNet: number
  PrevYearTotalUTNet: number

  TwoYearsAgoTotal: number
  TwoYearsAgoTotalNet: number
  TwoYearsAgoTotalTNet: number
  TwoYearsAgoTotalUTNet: number

  ThreeYearsAgoTotal: number
  ThreeYearsAgoTotalNet: number
  ThreeYearsAgoTotalTNet: number
  ThreeYearsAgoTotalUTNet: number

  CurrentYearTotal: number
  CurrentYearTotalNet: number
  CurrentYearTotalTNet: number
  CurrentYearTotalUTNet: number
}
export interface ICompetitor {
  Category: TCompetitorsSnapshotKeys
  CategoryName: string
  Competitors: ICompetitorsSnapshot[]
}

type TIssueStatus = 'Done' | 'WIP' | 'New'
export const issueStatuses: TIssueStatus[] = ['Done', 'WIP', 'New']

export interface IIssue {
  Issue: string
  HpResponse: string
  Status: TIssueStatus
}

export interface IOpportunity {
  TopDeal: string
  TotalUSD: number
  BusinessType: string
  CloseDate: string
}

export interface IHiddenSections {
  BalanceOfTradeHidden: number
}

export interface IAdditionalSections {
  RevenuePoly?: number
}

export interface ISoldProductData {
  [key: string]: ISoldProductCategory[]
}

export interface ISoldProductCategory {
  Name: string
  Products: ISoldProduct[]
}

export interface ISoldProduct {
  Name: string
  Value: number
  Checked: number
}

export interface ISoldProducts {
  Key: string
  Name: string
}

// Old version of product data
export interface IProducts {
  Key: string
  Name: string
}

export interface ICategorySoldProducts {
  Key: string
  Name: string
  Products: IProducts[]
}

export interface IELTLastMeetingData {
  id: string
  status: string
  action: string
  update: string
}

export interface IEltDocFormData {
  Company: IEltDocCompany
  LastEngagement: string[]
  MeetingObjectives: string[]
  HpExecutiveKeyPoints: string[]
  AdditionalNotes: string[]
  TopIssues: IEltTopIssue[]
  CompetitiveLandscape: ICompetitor[]
  BalanceOfTrade: IBalanceOfTrade[]
  TopOpportunities: IEltTopOpportunity[]
  FractionDigits: number
  CustomerRevenue: IEltCustomerRevenue[]
  CompanyAtGlanceInputs?: string[]
  CompanyPerformance: IEltCompanyPerformanceItem[]

  //Business Performance
  IsBusinessPerformanceTabEnabled: number
  BusinessPerformanceData: IEltBusinessPerformanceData[]
  IsRollup?: number
}

export interface IELTFormData {
  //first step
  MeetingMainInfo: IMeetingMainInfo
  HpAttendees: IAttendee[]
  AccountAttendees: IAttendee[]
  MeetingAgenda: IMeeetingAgenda[]
  MeetingLogisticsIsDone: number
  RevenueDesc: string
  CompanyAtGlance?: ICompanyAtGlance
  CompanyAtGlanceInputs?: string[]
  // second Step
  LastEngagement: string[]
  MeetingPurpose: string[]
  LongTermPriorities: string[]
  ShortTermPriorities: string[]
  SupportingPriorities: string[]
  MeetingSummary: IMeetingSummary
  MeetingsReviewIsDone: number
  //3 step
  Revenue: IRevenue[]
  CompetitiveLandscape: ICompetitor[]
  FinancialPerformance: string[]
  GoodNewsDesc: string[]
  Issues: IIssue[]
  FinancialSnapshotIsDone: number
  SoldPrintProducts?: ICategorySoldProducts[]
  SoldPSProducts?: ICategorySoldProducts[]
  SoldServicesProducts?: ICategorySoldProducts[]
  SoldProductData: ISoldProductData
  // 4 step
  NeedSupport: string[]
  MeetingObjective: string
  SupportTopics: ISupportTopic[]
  SupportReviewIsDone: number
  // 5 step
  BalanceOfTrade: IBalanceOfTrade[]
  BalanceOfTradeSummary: string[]
  KeyOpportunities: IOpportunity[]
  FinancialsIsDone: number
  // 6 step
  Account360IsDone: number
  FractionDigits: number
  //7 step
  FinancialsStatisticIsDone: number
  // Last Meeting step
  LastMeetingData: IELTLastMeetingData[]
  // other
  HiddenSections: IHiddenSections
  AdditionalSections?: IAdditionalSections
  HPSob: IHpSob[]
  PLC: IKpi[]
  PLCParams: Nullable<IPLCParams>
  IsRollup?: number
}

export type TEltFormData = IEltDocFormData | IELTFormData
